// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1xpMf","checkboxCol":"Table_checkboxCol__3b4Af","emailCol":"Table_emailCol__3kZBm","actionCol":"Table_actionCol__2u_PZ"};